import { createElement, clearNode } from "./dom.js"

export function buildShell(node, { exercise, t, modifier }) {
  clearNode(node)

  const title = typeof exercise?.title === "string" && exercise.title ? exercise.title : null
  const level = typeof exercise?.level === "string" && exercise.level ? exercise.level : null

  const heading = title
    ? createElement("h3", { class: "exw__title", text: title })
    : null
  const levelChip = level
    ? createElement("span", { class: "exw__level", text: level })
    : null
  const progress = createElement("p", { class: "exw__progress" })
  const body = createElement("div", { class: "exw__body" })
  const actions = createElement("div", { class: "exw__actions" })
  const status = createElement("div", {
    class: "exw__status",
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true"
  })

  const header = createElement("div", { class: "exw__header" }, [heading, levelChip, progress])
  const root = createElement(
    "div",
    { class: `exw exw--${modifier}`, "data-exw-type": exercise?.type || "" },
    [header, body, actions, status]
  )

  node.appendChild(root)

  return { root, header, progress, body, actions, status, t }
}

export function announce(status, message) {
  if (!status) return
  status.textContent = ""
  status.textContent = message
}

export function button(className, label, role) {
  return createElement("button", {
    type: "button",
    class: `exw__btn ${className}`,
    text: label,
    dataset: { exwRole: role }
  })
}

export function renderUnavailable(node, t) {
  clearNode(node)
  node.appendChild(
    createElement("div", { class: "exw exw--unavailable" }, [
      createElement("p", { class: "exw__unavailable-text", text: t("unavailable") })
    ])
  )
}
